var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBusinessTypeEcommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "55px",
    viewBox: "0 0 56 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Company-type",
    transform: "translate(-457.000000, -263.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-business-type-ecommerce",
    transform: "translate(457.000000, 263.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,19 C37.3,19 36,20.3 36,22 C36,23.3 36.8,24.4 38,24.8 C37.6,29.9 33.3,34 28,34 C22.7,34 18.5,29.9 18,24.8 C19.1,24.4 20,23.3 20,22 C20,20.3 18.7,19 17,19 C15.3,19 14,20.3 14,22 C14,23.3 14.9,24.4 16,24.8 C16.5,31.1 21.7,36 28,36 C34.3,36 39.5,31.1 40,24.8 C41.2,24.4 42,23.3 42,22 C42,20.3 40.7,19 39,19 Z M17,23.3 C16.3,23.3 15.7,22.7 15.7,22 C15.7,21.3 16.3,20.7 17,20.7 C17.7,20.7 18.3,21.3 18.3,22 C18.3,22.7 17.7,23.3 17,23.3 Z M39,23.4 C38.2,23.4 37.6,22.8 37.6,22 C37.6,21.2 38.2,20.6 39,20.6 C39.8,20.6 40.4,21.2 40.4,22 C40.4,22.8 39.8,23.4 39,23.4 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,47 C4.4,47 4,47.4 4,48 L4,50 C4,50.6 4.4,51 5,51 C5.6,51 6,50.6 6,50 L6,48 C6,47.4 5.6,47 5,47 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,47 C9.4,47 9,47.4 9,48 L9,50 C9,50.6 9.4,51 10,51 C10.6,51 11,50.6 11,50 L11,48 C11,47.4 10.6,47 10,47 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,47 C14.4,47 14,47.4 14,48 L14,50 C14,50.6 14.4,51 15,51 C15.6,51 16,50.6 16,50 L16,48 C16,47.4 15.6,47 15,47 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,47 C19.4,47 19,47.4 19,48 L19,50 C19,50.6 19.4,51 20,51 C20.6,51 21,50.6 21,50 L21,48 C21,47.4 20.6,47 20,47 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,47 C24.4,47 24,47.4 24,48 L24,50 C24,50.6 24.4,51 25,51 C25.6,51 26,50.6 26,50 L26,48 C26,47.4 25.6,47 25,47 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,47 C30.4,47 30,47.4 30,48 L30,50 C30,50.6 30.4,51 31,51 C31.6,51 32,50.6 32,50 L32,48 C32,47.4 31.6,47 31,47 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,47 C35.4,47 35,47.4 35,48 L35,50 C35,50.6 35.4,51 36,51 C36.6,51 37,50.6 37,50 L37,48 C37,47.4 36.6,47 36,47 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,47 C40.4,47 40,47.4 40,48 L40,50 C40,50.6 40.4,51 41,51 C41.6,51 42,50.6 42,50 L42,48 C42,47.4 41.6,47 41,47 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,47 C45.4,47 45,47.4 45,48 L45,50 C45,50.6 45.4,51 46,51 C46.6,51 47,50.6 47,50 L47,48 C47,47.4 46.6,47 46,47 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,48 L50,50 C50,50.6 50.4,51 51,51 C51.6,51 52,50.6 52,50 L52,48 C52,47.4 51.6,47 51,47 C50.4,47 50,47.4 50,48 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1,13.8 C53,12.2 51.7,11 50.1,11 L39.9,11 C39.4,4.9 34.3,0 28,0 C21.7,0 16.6,4.9 16.1,11 L5.9,11 C4.3,11 3,12.2 2.9,13.8 L0.2,51.8 C0.1,52.6 0.4,53.4 1,54 C1.6,54.6 2.4,55 3.2,55 L52.9,55 C53.7,55 54.5,54.7 55.1,54 C55.7,53.3 56,52.6 55.9,51.7 L53.1,13.8 Z M28,2 C33.2,2 37.4,6 37.9,11 L18.1,11 C18.6,6 22.8,2 28,2 Z M53.6,52.7 C53.4,52.9 53.1,53 52.9,53 L3.1,53 C2.8,53 2.6,52.9 2.4,52.7 C2.2,52.5 2.1,52.2 2.1,51.9 L4.6,17 L39,17 C39.6,17 40,16.6 40,16 C40,15.4 39.6,15 39,15 L4.8,15 L4.9,13.9 C4.9,13.4 5.4,13 5.9,13 L50.2,13 C50.7,13 51.2,13.4 51.2,13.9 L53.9,51.9 C53.9,52.2 53.8,52.5 53.6,52.7 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,15 L43,15 C42.4,15 42,15.4 42,16 C42,16.6 42.4,17 43,17 L47,17 C47.6,17 48,16.6 48,16 C48,15.4 47.6,15 47,15 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusinessTypeEcommerce);
export default __webpack_public_path__ + "static/media/icon-business-type-ecommerce.a84fdaf9cf5dc42fa81f54b158c55aac.svg";
export { ForwardRef as ReactComponent };